import { render, staticRenderFns } from "./GTM.vue?vue&type=template&id=45da6626&scoped=true&"
import script from "./GTM.vue?vue&type=script&lang=js&"
export * from "./GTM.vue?vue&type=script&lang=js&"
import style0 from "./GTM.vue?vue&type=style&index=0&id=45da6626&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45da6626",
  null
  
)

export default component.exports